import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { DefaultForm } from "../../components";
import { CommonCollectorModel } from "../../entities/common";
import { useGetCompaniesSelectFilterQuery } from "../../features/api/apiSlice";

interface CompanyShareholderCollectorProps {
  collectCallback: (data: CommonCollectorModel) => Promise<boolean>;
}

export const CompanyShareholderCollector = ({ collectCallback }: CompanyShareholderCollectorProps) => {
  const [isCollecting, setIsCollecting] = useState(false);

  let model: CommonCollectorModel = {
    symbols: [],
  };

  const onFinish = async (values: any) => {
    let collectModel: CommonCollectorModel = {
      ...values,
    };

    setIsCollecting(true);

    await collectCallback(collectModel);

    setIsCollecting(false);
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect
        name="symbols"
        label="none"
        placeholder="انتخاب شرکت ها"
        multiple={true}
        recordId={(x) => x.symbol}
        wrapperCol={{ xs: 24, lg: 12 }}
        query={useGetCompaniesSelectFilterQuery}
        displayText={(x) => `${x.symbol} (${x.name})`}
        isPersian={true}
      />

      <DefaultForm.SubmitButton loading={isCollecting} icon={<FontAwesomeIcon className="anticon" icon={faPlusCircle} />}>
        کالکت
      </DefaultForm.SubmitButton>
    </DefaultForm>
  );
};
